import Axios from "axios";
import {
  SET_LC_IMPORT_LC_SHIPMENT_LIST,
  UNSET_LC_IMPORT_LC_SHIPMENT_LIST,
  SET_EDITING_LC_IMPORT_LC_SHIPMENT,
  UNSET_EDITING_LC_IMPORT_LC_SHIPMENT,
} from "@/store/mutation-types";
import {
  saveUpdateLcImportLcShipment,
  getLcImportLcShipmentList,
  getLcImportLcShipmentById as getLcImportLcShipmentByIdApi,
} from "@/store/api";

// initial state
const state = {
  lcImportLcShipmentList: [],
  editingLcImportLcShipment: null,
};

const getters = {
  getLcImportLcShipmentList(state) {
    return state.lcImportLcShipmentList;
  },
  getEditingLcImportLcShipment(state) {
    return state.editingLcImportLcShipment;
  },
};

const mutations = {
  [SET_LC_IMPORT_LC_SHIPMENT_LIST](state, data) {
    state.lcImportLcShipmentList = data;
  },
  [UNSET_LC_IMPORT_LC_SHIPMENT_LIST](state) {
    state.lcImportLcShipmentList = [];
  },
  [SET_EDITING_LC_IMPORT_LC_SHIPMENT](state, data) {
    state.editingLcImportLcShipment = data;
  },
  [UNSET_EDITING_LC_IMPORT_LC_SHIPMENT](state) {
    state.editingLcImportLcShipment = null;
  },
};

const actions = {
  saveUpdateLcImportLcShipment({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLcImportLcShipment, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getLcImportLcShipmentList({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcImportLcShipmentList,{ params })
        .then(function (response) {
          commit(SET_LC_IMPORT_LC_SHIPMENT_LIST, response.data.data || []);
          resolve(response);
        })
        .catch(function (error) {
          commit(UNSET_LC_IMPORT_LC_SHIPMENT_LIST);
          reject(error);
        });
    });
  },

  getLcImportLcShipmentById({ commit }, id) {
    const url = `${getLcImportLcShipmentByIdApi}${id}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(url)
        .then((response) => {
          commit(SET_EDITING_LC_IMPORT_LC_SHIPMENT, response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};


